module.exports = __webpack_public_path__ + "img/logo-old.5f7ad989.png";